import React, { FC } from 'react'

import { UpIcon, DownIcon, RightIcon, LeftIcon } from '../../Icons'

import { Label, ButtonKey, KeysRow, SpaceKey } from './styled'

import { ActionAnswer } from 'src/api/quizzes/types'

interface Props {
  answerQuestion: (answer: ActionAnswer) => void
}
export const KeyboardHint: FC<Props> = ({ answerQuestion }) => (
  <div>
    <KeysRow>
      <ButtonKey onClick={() => answerQuestion(ActionAnswer.left)}>
        <LeftIcon />
        <Label>Meh</Label>
      </ButtonKey>
      <ButtonKey onClick={() => answerQuestion(ActionAnswer.up)}>
        <UpIcon />
        <Label>Love</Label>
      </ButtonKey>
      <ButtonKey onClick={() => answerQuestion(ActionAnswer.down)}>
        <DownIcon />
        <Label>Nope</Label>
      </ButtonKey>
      <ButtonKey onClick={() => answerQuestion(ActionAnswer.right)}>
        <RightIcon />
        <Label>Like</Label>
      </ButtonKey>
    </KeysRow>
    <KeysRow>
      <ButtonKey onClick={() => answerQuestion(ActionAnswer.skip)}>
        <SpaceKey>space</SpaceKey>
        <Label>Skip</Label>
      </ButtonKey>
    </KeysRow>
  </div>
)
